import { useTheme } from '../context/ThemeContext';

type Theme = 'light' | 'dark' | 'system';

const NEXT_THEME: Record<Theme, Theme> = {
  light: 'dark',
  dark: 'system',
  system: 'light',
};

const SUN_ICON = (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
    />
  </svg>
);

const MOON_ICON = (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
    />
  </svg>
);

const SYSTEM_ICON = (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

const THEME_META: Record<Theme, { label: string; icon: JSX.Element }> = {
  light: { label: 'Jasny', icon: SUN_ICON },
  dark: { label: 'Ciemny', icon: MOON_ICON },
  system: { label: 'System', icon: SYSTEM_ICON },
};

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const current = THEME_META[theme];
  const next = THEME_META[NEXT_THEME[theme]];

  return (
    <button
      onClick={() => setTheme(NEXT_THEME[theme])}
      className="p-2 rounded-md text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-700 dark:hover:text-slate-300 transition-colors"
      title={`Motyw: ${current.label} → ${next.label}`}
      aria-label={`Motyw: ${current.label}. Kliknij, aby przełączyć na ${next.label}.`}
    >
      {current.icon}
    </button>
  );
}
